import { Component } from '@angular/core';

/** Entry point propio de Historial Hormigón; delegación temporal al legacy. */
@Component({
  selector: 'app-hormigon-mixer-history-entry',
  template: '<app-hormigon-history></app-hormigon-history>',
  standalone: false,
})
export class HormigonMixerHistoryEntryComponent {}
